const BaseTd = ({ children, extraClass }) => {
  return (
    <td className={` py-4 px-3 text-base text-[#2D2D34] dark:text-[#ffffff] first:rounded-tl-[8px] first:rounded-bl-[8px] first:rounded-tr-none first:rounded-br-none last:rounded-tr-[8px] last:rounded-br-[8px] last:rounded-tl-none last:rounded-bl-none ${extraClass}`}>
      {children}
    </td>
  );
};

export default BaseTd;
